"use strict";

const { maskPhone } = require("../../utils/masks");

$(document).ready(function () {
    var $textArea = $("#consulting-message");
    var $arrows = $(".textarea-arrow");

    maskPhone($("#consulting-phone"));

    $arrows.on("click", function () {
        var scrollLocation = $textArea.scrollTop();
        if ($(this).hasClass("up")) {
            $textArea.scrollTop(scrollLocation - 20);
        } else {
            $textArea.scrollTop(scrollLocation + 20);
        }
    });

    $(".back-link").on("click", function () {
        switchDisplay();
    });

    $(".consulting-form").on("submit", function (e) {
        e.preventDefault();
        var $form =  $(this);
        var formData = $form.serialize();

        $.ajax({
            url: $form.attr("action"),
            type: "POST",
            dataType: "json",
            data: formData,
            /**
             * Callback function for a successful AJAX request
             * @param {Object} data - the response data from the AJAX request
             * @returns {void}
             */
            success: function (data) {
                if (data.success) {
                    switchDisplay();
                }
            }
        });
    });
});

function switchDisplay() {
    const $successDisplay = $(".success-message-display");
    const $formDisplay = $(".form-display");
    const $containerForm = $(".consultation-content");
    const $logo = $(".consultation-logo");

    $successDisplay.toggleClass("d-block d-none");
    $formDisplay.toggleClass("d-block d-none");
    $logo.toggleClass("d-none");

    if ($formDisplay.hasClass("d-block")) {
        $containerForm.removeClass("small-size").addClass("normal-size");
    } else {
        $containerForm.removeClass("normal-size").addClass("small-size");
    }
}
